import axios from 'axios'

// Create axios instance with default config
const api = axios.create({
    // Em produção (Build), usar path relativo (vazio) para evitar problemas de CORS/HTTPS misto
    // Em dev, usa a variável de ambiente (localhost ou domínio externo)
    baseURL: import.meta.env.PROD ? '' : (import.meta.env.VITE_API_URL || ''),
    timeout: 60000,
    withCredentials: true, // Enviar cookies de sessão
    headers: {
        'Content-Type': 'application/json'
    }
})

// Request interceptor
api.interceptors.request.use(
    (config) => {
        // Add auth token if available
        const token = localStorage.getItem('auth_token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Response interceptor
api.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response?.status === 401) {
            // Handle unauthorized - redirect to login
            localStorage.removeItem('auth_token')
            window.location.href = '/login'
        }
        return Promise.reject(error)
    }
)

export { api }
export default api
